import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export enum LoginType {
  admin = 'admin',
  backoffice = 'backoffice'
}

interface LoginResponse {
  token: string,
  refreshToken: string,
  tokenExpiration: string,
  refreshTokenExpiration: string
}

export interface LoginState {
  value: number
}
interface AuthValue {
  auth: string | null,
  LoginType : LoginType,
  isLogged: boolean,
  loginResponse: LoginResponse | null
}

interface Company {
  tenantName: string
  tenantValue: string
  tenantLogo: string
}

const loginState: LoginState = {
  value: 0,
}

const companyState: Company = {
  tenantName: '',
  tenantValue: '',
  tenantLogo: ''
}

const authState: AuthValue  = {
  auth: localStorage.getItem('auth'),
  LoginType: LoginType.backoffice,
  isLogged: false,
  loginResponse: null
}

export const loginSlice = createSlice({
  name: 'login',
  initialState: loginState,
  reducers: {
  },
})

export const companySlice = createSlice({
  name: 'company',
  initialState: companyState,
  reducers: {
    addCompany: (state, action: PayloadAction<Company>) => {
      state.tenantLogo = action.payload.tenantLogo
      state.tenantName = action.payload.tenantName
      state.tenantValue = action.payload.tenantValue
    }
  },
})

export const authSlice = createSlice({
  name: 'auth',
  initialState: authState,
  reducers: {
    addAuth: (state, action: PayloadAction<AuthValue>) => {
      state.auth = action.payload.auth;
      state.LoginType = action.payload.LoginType;
      state.isLogged = action.payload.isLogged;
      state.loginResponse = action.payload.loginResponse;
    }
  }
});

// Action creators are generated for each case reducer function
export const { } = loginSlice.actions

export const { addAuth } = authSlice.actions
export const { addCompany } = companySlice.actions